import { createTokenHeader } from '../utils/functions/headers';
import {
  TImportDiscountResponse,
  TPricingApiParams,
  Pricing,
} from '../utils/types';
import { emptySplitApi } from './emptySplitApi';

export const PricingService = emptySplitApi.injectEndpoints(
  {
    endpoints: (build) => ({
      getPricingList: build.query<
        { data: Pricing[]; totalCount: number },
        TPricingApiParams
      >({
        query: ({ plantCode, catalogId, page, size }) => ({
          url: `product/price/list?sort=createdDate,desc&status.equals=1`,
          method: 'GET',
          params: {
            'werks.contains': catalogId,
            'matnr.contains': catalogId,
            page: page,
            size: size,
            ...(plantCode && {
              'plant.contains': plantCode,
            }),
          },
        }),
        transformResponse: (
          data: Pricing[],
          meta: Response
        ) => {
          const totalCount =
            meta.headers.get('X-total-count');
          return {
            data,
            totalCount: Number(totalCount ? totalCount : 0),
          };
        },
      }),
      priceImport: build.mutation<
        TImportDiscountResponse,
        { data: FormData; enterprise: string }
      >({
        query: ({ data, enterprise }) => ({
          url: `products/price/import/${enterprise}`,
          method: 'POST',
          data: data,
          headers: createTokenHeader(),
        }),
      }),
      matnrPriceSync: build.mutation<
        unknown,
        { matnr: string; werks: string }
      >({
        query: (data) => ({
          url: 'products/price/sync',
          method: 'POST',
          data,
        }),
      }),
      exportPrice: build.mutation({
        query: (data) => ({
          url: 'products/price-enterprise/export',
          method: 'POST',
          data,
        }),
      }),
      priceSyncByPlant: build.mutation({
        query: ({ plant }) => ({
          url: `products/sap-sync?plantCode=${plant}&jobName=PRICE_PULL_JOB`,
          method: 'PUT',
        }),
      }),
      updatePrice: build.mutation({
        query: ({ data }) => ({
          url: 'product-prices',
          method: 'POST',
          data,
        }),
      }),
    }),
  }
);

export const {
  useGetPricingListQuery,
  usePriceImportMutation,
  useMatnrPriceSyncMutation,
  useExportPriceMutation,
  usePriceSyncByPlantMutation,
} = PricingService;
